import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';

const HighlightPrefferedStore = ({ children , title  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "stores-v2-highlight-preferred-store"
    }, title ? /*#__PURE__*/ React.createElement(Heading, {
        component: "h5",
        variant: "subheading1"
    }, title) : null, children);
};
var HighlightPreferredStore = HighlightPrefferedStore;

export { HighlightPreferredStore as default };
//# sourceMappingURL=HighlightPreferredStore.js.map
